import React, {useEffect, useState} from "react";
import useToastNotify from "../../../hook/useToastNotify";
import {IRouteParams} from "../../../contracts/router";
import {useLocation, useParams} from "react-router-dom";
import useQuery from "../../../hook/useQuery";
import httpClient from "../../../services/httpClient";
import {basketApi} from "../../../constans/apiUrls";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import {isNotEmpty, priceFormatWithUnitToman} from "../../../helpers/functions";
import PageHeader from "../../Elements/PageHeader";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import {IBasketData} from "../../../contracts/data/basket";
import {IRouterListToData} from "../../../contracts/data/router";
import DetailsCard from "../../Elements/DetailsCard";


const BasketDetails:React.FC = () => {
    const {toastNotify} = useToastNotify()
    const [data, setData] = useState<IBasketData>({
        id: 0,
        user: '',
        total_price: 0,
        final_price: 0,
        items: [],
    });
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);
    const params:IRouteParams = useParams();
    const queryParams = useQuery()
    const location = useLocation<IRouterListToData>()

    const titleHeadTable: Array<string> = ['#', 'عنوان محصول', 'درصد تخفیف','قیمت واحد محصول', 'قیمت نهایی محصول']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${basketApi.view}/${queryParams.get("id")}`)
            .then(response => {
                if (response.status === 200) {
                    setData(response?.data?.data)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchItemsData()
    }, [])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data?.items.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.info?.title} hasImage={true} image={isNotEmpty(item?.info?.cover_image_url) ? item?.info?.cover_image_url! : item?.info?.cover_image_url!} isPrimary={true}/></TableTd>
            <TableTd><TableTdContent content={item?.info?.percent > 0 ? `${item?.info?.percent}%` : "-"} /></TableTd>
            <TableTd><TableTdContent content={priceFormatWithUnitToman(item?.info?.price)} /></TableTd>
            <TableTd><TableTdContent content={priceFormatWithUnitToman(item?.info?.real_price)} /></TableTd>
        </TableTr>
    )

    return(
        <React.Fragment>
            <PageHeader title={`سبد خرید "${queryParams?.get('name')}"`} isBackBtn urlBackBtn={`${location?.state?.page}?page_num=${location?.state?.page_num}`} />
            <div className={"border rounded-xl bg-blue-50 p-4 mb-6"}>
                <h4 className={"text-gray-400 text-xl font-bold pb-4 mb-4 border-b border-gray-300 border-dashed"}>اطلاعات کلی سبد</h4>
                <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>
                    <DetailsCard title={"نام و نام خانوادگی"} content={data?.user} />
                    <DetailsCard title={"هزینه کل"} content={data?.total_price > 0 ? priceFormatWithUnitToman(data?.total_price) : "-"} />
                    <DetailsCard title={"هزینه نهایی"} content={data?.final_price > 0 ? priceFormatWithUnitToman(data?.final_price) : "-"} />
                </div>
            </div>
            <Table isLoading={loading} title={'لیست موجودی سبد خرید'} titlesTable={titleHeadTable} isSearch={false}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"محصولی در سبد خرید یافت نشد"}/>}
            </Table>
        </React.Fragment>
    )
}

export default BasketDetails